module.exports = __webpack_public_path__ + "static/img/home_banner.60ad1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_banner.png
// module id = ILbt
// module chunks = 0